<section #heroRef class="pt-32 pb-16 md:pt-40 md:pb-24 relative overflow-hidden">
  <!-- Background Gradient -->
  <div class="absolute inset-0 bg-gradient-to-b from-mint-light/20 to-transparent"></div>

  <!-- Decorative Circles -->
  <div class="absolute top-20 right-0 w-64 h-64 rounded-full bg-mint/10 filter blur-3xl"></div>
  <div class="absolute bottom-0 left-10 w-40 h-40 rounded-full bg-lavender/20 filter blur-3xl"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="max-w-4xl mx-auto text-center">
      <span class="subtitle inline-block mb-4 animate-on-load opacity-0 transform translate-y-4 transition-all duration-700 delay-100">
        Naturally Grown Wellness
      </span>

      <h1 class="heading-xl mb-6 animate-on-load opacity-0 transform translate-y-4 transition-all duration-700 delay-200">
        Nourish Your Body with Ancient Wellness Solutions
      </h1>

      <p class="body-lg text-forest/80 mb-8 max-w-2xl mx-auto animate-on-load opacity-0 transform translate-y-4 transition-all duration-700 delay-300">
        Discover premium quality organic Ashwagandha, Shilajit, and other traditional remedies, sourced sustainably and crafted for modern lifestyles.
      </p>

      <div class="flex flex-col sm:flex-row justify-center gap-4 mb-16 animate-on-load opacity-0 transform translate-y-4 transition-all duration-700 delay-400">
        <a routerLink="/shop" class="button-primary flex items-center justify-center gap-2 group">
          <span>Shop Premium Herbs</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7-7l7 7-7 7" />
          </svg>
        </a>
        <a (click)="navigateToHome('footer')" class="button-secondary cursor-pointer">Learn More</a>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto animate-on-load opacity-0 transform translate-y-4 transition-all duration-700 delay-500">
        @for (item of homePageUSP; track $index) {
          <div class="glass-card p-4 rounded-lg">
            <div class="text-forest font-semibold text-lg md:text-xl mb-1">{{item.val}}</div>
            <div class="text-sm text-forest/70">{{item.title}}</div>
          </div>
        }
        <!-- <div class="glass-card p-4 rounded-lg">
          <div class="text-forest font-semibold text-lg md:text-xl mb-1">Ethically</div>
          <div class="text-sm text-forest/70">Sourced</div>
        </div>
        <div class="glass-card p-4 rounded-lg">
          <div class="text-forest font-semibold text-lg md:text-xl mb-1">Lab</div>
          <div class="text-sm text-forest/70">Tested</div>
        </div>
        <div class="glass-card p-4 rounded-lg">
          <div class="text-forest font-semibold text-lg md:text-xl mb-1">3,500+</div>
          <div class="text-sm text-forest/70">Reviews</div>
        </div> -->
      </div>
    </div>
  </div>
</section>
